import { type TranslationTree } from '@/i18n/types';

export const messages = {
  title: 'Crie o primeiro evento',
  hint: 'Os eventos aprovados pela Bodyprint aparecem no app para os atletas da região.',
  create: 'Novo evento',
  filteredTitle: 'Nenhum evento neste status',
  filteredHint: 'Escolha outra aba para ver os demais eventos.',
} satisfies TranslationTree;
